var thread = null;
var user = currentUser ?? null;
var stopRequested = false;
var selectedImage = null;
var selectedImageSrc = null;
var chatStorageKey = null;
var streamRef = null;
var isSending = false;
var lastServerMsgCount = 0;
var THREAD_COOKIE = "chat_thread";

function createBotAvatar() {
    var image = document.createElement("img");
    image.className = "rounded-circle align-self-end me-2";
    image.src = APP_URL + "/img/c" + imageId + ".png";
    image.width = "30";
    image.height = "30";
    return image;
}

function renderBotHtml(converter, text) {
    return converter.makeHtml(text).replace(/ã€[^ã€‘]*ã€‘/g, '');
}

function scrollChatAnimated() {
    var chatContainer = document.getElementById("chat");
    if (!chatContainer) return;
    chatContainer.scrollTo({
        top: chatContainer.scrollHeight,
        behavior: 'instant'
    });
}

function setButtonsState(state) {
    let newChatButton = document.getElementById("new-chat");
    let historyButton = document.getElementById('historyButton');
    let attachButton = document.getElementById("attach-image");
    let stopButton = document.getElementById('stop');
    let sendButton = document.getElementById('send');

    if (state === "streaming") {
        if (newChatButton) newChatButton.style.display = 'none';
        if (historyButton) historyButton.style.display = 'none';
        if (attachButton) attachButton.style.display = 'none';
        if (sendButton) sendButton.style.display = 'none';
        if (stopButton) stopButton.style.display = 'block';
        return;
    }

    if (newChatButton) newChatButton.style.display = 'block';
    if (historyButton) historyButton.style.display = 'block';
    if (attachButton) attachButton.style.display = 'block';
    if (sendButton) sendButton.style.display = 'block';
    if (stopButton) stopButton.style.display = 'none';
}

function clearSelectedImage() {
    var fileInput = document.getElementById("image-file");
    if (fileInput) fileInput.value = '';
    selectedImage = null;
    selectedImageSrc = null;
    var preview = document.getElementById("image-preview-container");
    if (preview) preview.innerHTML = '';
}

function getCookie(name) {
    try {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\^+])/g, '\\$1') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
        return null;
    }
}

function setCookie(name, value, days) {
    try {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + encodeURIComponent(value || "") + expires + "; path=/";
    } catch (e) {
        // Ignore cookie failures (e.g., blocked in iframe)
    }
}

function deleteCookie(name) {
    try {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    } catch (e) {
        // Ignore cookie failures
    }
}

function storageGet(key, cb) {
    try {
        cb(null, localStorage.getItem(key));
    } catch (e) {
        cb(e);
    }
}

function storageSet(key, value, cb) {
    try {
        localStorage.setItem(key, value);
        if (cb) cb(null, true);
    } catch (e) {
        if (cb) cb(e);
    }
}

function storageRemove(key, cb) {
    try {
        localStorage.removeItem(key);
        if (cb) cb(null, true);
    } catch (e) {
        if (cb) cb(e);
    }
}

function getChatStorageKey() {
    if (chatStorageKey) return chatStorageKey;
    var key = "chat:thread:" + (chatId ?? "default");
    chatStorageKey = key;
    return key;
}

function persistChat() {
    var chatContainer = document.getElementById("chat");
    if (!chatContainer) return;

    var rows = Array.from(chatContainer.querySelectorAll(".row-chat"));
    var messages = rows.map(function (row) {
        var user = row.querySelector(".user-message");
        if (user) return { role: "user", html: user.innerHTML };
        var bot = row.querySelector(".bot-reply");
        if (bot) return { role: "bot", html: bot.innerHTML };
        return null;
    }).filter(Boolean);

    var payload = {
        thread: thread ?? null,
        messages: messages
    };

    storageSet(getChatStorageKey(), JSON.stringify(payload), function (err) {
        if (err) console.warn("No se pudo persistir el chat en storage:", err);
    });
}

async function getConversationFromServer(threadId) {
    if (!threadId) return null;

    try {
        let response = await fetch(APP_URL + "/getConversation/" + encodeURIComponent(threadId), {
            method: "GET",
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        });
        if (!response.ok) {
            console.warn("Respuesta no OK al obtener la conversación del servidor:", response.status);
            return null;
        }
        let data = await response.json();
        return data;
    } catch (e) {
        console.warn("No se pudo obtener la conversación del servidor:", e);
        return null;
    }
}

async function restoreChat() {
    const drawConversation = (messages) => {
            const converter = new showdown.Converter();

            var rowTyping = document.querySelector(".row-typing");
            if (!rowTyping) return;

            messages.forEach(function (msg) {
                // No mostrar respuestas del bot con "Sorry I cannot answer"
                if (msg.role !== "user" && msg.html && msg.html.includes("Sorry I cannot answer")) return;

                var divRow = document.createElement("div");
                divRow.className = "row row-chat";

                var divCol = document.createElement("div");
                if (msg.role === "user") {
                    divCol.className = "offset-2 col-10 d-inline-flex justify-content-end";
                } else {
                    divCol.className = "col-10 d-inline-flex";
                    divCol.appendChild(createBotAvatar());
                }

                var divMsg = document.createElement("div");
                divMsg.className = msg.role === "user" ? "user-message" : "bot-reply";
                divMsg.innerHTML = msg.html ? renderBotHtml(converter, msg.html): "";

                divCol.appendChild(divMsg);
                divRow.appendChild(divCol);
                rowTyping.parentNode.insertBefore(divRow, rowTyping);
            });

            // Sincronizar el contador con lo que el servidor nos dio
            lastServerMsgCount = messages.length;

            scrollChatAnimated();
    }

    // Prioridad: thread indicado en la URL (deep-link desde notificación)
    if (!thread) {
        var urlThread = new URLSearchParams(window.location.search).get('thread');
        if (urlThread) {
            thread = urlThread;
            setCookie(THREAD_COOKIE, thread, 30);
        }
    }

    if (!thread) {
        thread = getCookie(THREAD_COOKIE);
    }

    if (question) {
        thread = null;
        let textBox = document.getElementById("text-box");
        textBox.value = question;
        send();
    } else {
        if(thread){
            let conversation = await getConversationFromServer(thread);
            if (conversation && Array.isArray(conversation)) {
                drawConversation(conversation);
            }
        } else {
            var key = getChatStorageKey();
            storageGet(key, async function (err, raw) {
                if (err) {
                    console.warn("No se pudo leer el chat desde storage:", err);
                    return;
                }
                if (!raw) return;

                try {
                    var payload = JSON.parse(raw);
                    thread = payload.thread ?? null;
                    let conversation = await getConversationFromServer(thread);
                    if (conversation && Array.isArray(conversation)) {
                        drawConversation(conversation);
                    } else {
                        var messages = payload.messages ?? [];

                        drawConversation(messages);
                    }
                } catch (e) {
                    console.warn("No se pudo restaurar el chat:", e);
                }
            });
        }
    }
}

function clearChat() {
    var chatContainer = document.getElementById("chat");

    thread = null;
    stopRequested = false;
    lastServerMsgCount = 0;

    if (streamRef) {
        try { streamRef.close(); } catch (e) {}
        streamRef = null;
    }

    if (chatContainer) {
        var rows = Array.from(chatContainer.querySelectorAll(".row-chat"));
        rows.forEach(function (row) { row.remove(); });
    }

    var textBox = document.getElementById("text-box");
    if (textBox) {
        textBox.disabled = false;
        textBox.value = '';
        textBox.focus();
    }

    var rowTyping = document.querySelector(".row-typing");
    if (rowTyping) rowTyping.style.display = 'none';
    setButtonsState("idle");

    storageRemove(getChatStorageKey(), function (err) {
        if (err) console.warn("No se pudo limpiar el chat en storage:", err);
    });
    deleteCookie(THREAD_COOKIE);

    clearSelectedImage();
}

function handleImageFile(file) {
    if (!file || !file.type.startsWith('image/')) return;
    
    selectedImage = file;
    const previewContainer = document.getElementById("image-preview-container");
    previewContainer.innerHTML = '';
    
    const reader = new FileReader();
    reader.onload = function (e) {
        selectedImageSrc = e.target.result;
        const img = document.createElement("img");
        img.src = selectedImageSrc;
        img.style.cssText = `width: 40px; height: 40px; object-fit: cover; border-radius: 5px; margin-right: 5px; cursor: pointer;`;
        img.title = "Click para eliminar";
        img.addEventListener("click", function () {
            clearSelectedImage();
        });
        previewContainer.appendChild(img);
    };
    reader.readAsDataURL(selectedImage);
}

// DOMContentLoaded equivalente a $(function)
document.addEventListener('DOMContentLoaded', function () {
    const imageFileInput = document.getElementById("image-file");
    restoreChat();
     // Actualizar conversación cada 5 segundos
    setInterval(() => {
        refreshConversation();
    }, 5000);
    // Abrir selector de archivo al hacer click en el botón
    const attachImageBtn = document.getElementById("attach-image");
    if (attachImageBtn) {
        attachImageBtn.addEventListener("click", function () {
            imageFileInput.click();
        });
    }

    // Guardar archivo seleccionado en variable
    if (imageFileInput) {
        imageFileInput.addEventListener("change", function (e) {
            handleImageFile(e.target.files[0]);
        });
    }

    // Evento keypress en document
    document.addEventListener("keypress", function (e) {
        const textBox = document.getElementById("text-box");
        if (e.which == 13 && document.activeElement === textBox) {
            send();
        }
    });

    // Click en conversación
    const conversations = document.querySelectorAll('.conversation-link');
    conversations.forEach(function (conv) {
        conv.addEventListener('click', function (event) {
            event.preventDefault();
            const threadId = this.getAttribute('data-thread');
            if (threadId) {
                clearChat();
                thread = threadId;
                setCookie(THREAD_COOKIE, thread, 30);
                restoreChat();
            }
            document.getElementById('closeHistory').click();
        });
    });

    // Click en send
    const sendBtn = document.getElementById("send");
    if (sendBtn) {
        sendBtn.addEventListener("click", function (e) {
            send();
        });
    }

    // Click en stop
    const stopBtn = document.getElementById("stop");
    if (stopBtn) {
        stopBtn.addEventListener("click", function (e) {
            stopBtn.style.display = 'none';
            stop();
        });
    }

    const newChatBtn = document.getElementById("new-chat");
    if (newChatBtn) {
        newChatBtn.addEventListener("click", function () {
            clearChat();
        });
    }

    // Drag and drop
    document.body.addEventListener('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    document.body.addEventListener('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.files.length > 0) {
            handleImageFile(e.dataTransfer.files[0]);
        }
    });
});
async function refreshConversation() {

    // No refrescar mientras se está enviando un mensaje o haciendo streaming
    if (isSending) return;

    if (!thread) return;

    const conversation = await getConversationFromServer(thread);

    if (!Array.isArray(conversation)) return;

    const rowTyping = document.querySelector(".row-typing");
    if (!rowTyping) return;

    // Si no hay mensajes nuevos respecto a lo que ya conocemos del servidor, no hacer nada
    if (conversation.length <= lastServerMsgCount) return;

    // Append solo los mensajes nuevos
    const converter = new showdown.Converter();
    const newMessages = conversation.slice(lastServerMsgCount);

    newMessages.forEach(msg => {

        // No mostrar respuestas del bot con "Sorry I cannot answer"
        if (msg.role !== "user" && msg.html && msg.html.includes("Sorry I cannot answer")) return;

        const divRow = document.createElement("div");
        divRow.className = "row row-chat";

        const divCol = document.createElement("div");

        if (msg.role === "user") {
            divCol.className = "offset-2 col-10 d-inline-flex justify-content-end";
        } else {
            divCol.className = "col-10 d-inline-flex";
            divCol.appendChild(createBotAvatar());
        }

        const divMsg = document.createElement("div");

        divMsg.className = msg.role === "user"
            ? "user-message"
            : "bot-reply";

        divMsg.innerHTML = msg.html
            ? renderBotHtml(converter, msg.html)
            : "";

        divCol.appendChild(divMsg);
        divRow.appendChild(divCol);

        rowTyping.parentNode.insertBefore(divRow, rowTyping);
    });

    // Actualizar el contador con el total del servidor
    lastServerMsgCount = conversation.length;

    scrollChatAnimated();
}
function stop() {
    stopRequested = true;
}

function send() {
    isSending = true;
    let imageContent = selectedImage ? selectedImageSrc : null;
    let textBox = document.getElementById("text-box");
    let text = textBox.value;
    let question = text.trim();

    if (!question && !imageContent) {
        isSending = false;
        return;
    }

    if (imageContent) {
        text = `<div class="text-center"><img src="${imageContent}" width="150"></div>${text}`;
    }
    
    textBox.value = "";
    
    // Crear elementos del mensaje del usuario
    const divRow = document.createElement("div");
    divRow.className = "row row-chat";
    
    const divOffsetCol = document.createElement("div");
    divOffsetCol.className = "offset-2 col-10 d-inline-flex justify-content-end";
    
    const divUserMessage = document.createElement("div");
    divUserMessage.className = "user-message";
    divUserMessage.innerHTML = text;

    divOffsetCol.appendChild(divUserMessage);
    divRow.appendChild(divOffsetCol);
    
    const rowTyping = document.querySelector(".row-typing");
    rowTyping.parentNode.insertBefore(divRow, rowTyping);
    rowTyping.style.display = 'block';
    textBox.disabled = true;
    persistChat();
    
    scrollChatAnimated();

    var formData = new FormData();
    formData.append('chat', chatId);
    formData.append('text', question);
    formData.append('thread', thread ?? '');
    formData.append('stream', true);
    if (user) {
        formData.append('user', user);
    }
    if (origin) {
        formData.append('origin', origin);
    }
    if (selectedImage) {
        formData.append('image', selectedImage);
        // limpiar preview
        clearSelectedImage();
    }
    
    fetch(APP_URL + "/send", {
        method: "POST",
        body: formData,
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    })
    .then(response => response.json())
    .then(response => {
        const rowTyping = document.querySelector(".row-typing");
        const endRowTyping = () => {
            rowTyping.style.display = 'none';
            textBox.disabled = false;
            textBox.focus();
        }

        thread = response.thread;
        if (thread) setCookie(THREAD_COOKIE, thread, 30);
        persistChat();
        const converter = new showdown.Converter();
        
        const image = createBotAvatar();

        var streamId = response.streamId ?? null;

        const divBotMessage = document.createElement("div");
        divBotMessage.className = "bot-reply";

        const finEscritura = () => {
            const divCol = document.createElement("div");
            divCol.className = "col-10 d-inline-flex";
            divCol.appendChild(image.cloneNode(true));
            divCol.appendChild(divBotMessage);
            
            const divChatRow = document.createElement("div");
            divChatRow.className = "row row-chat";
            divChatRow.appendChild(divCol);
            
            rowTyping.parentNode.insertBefore(divChatRow, rowTyping);
        }

        if (streamId != null) {
            setButtonsState("streaming");
            stopRequested = false;
            var initiated = false;
            var stream = new EventSource(APP_URL + "/stream?streamId=" + streamId);
            streamRef = stream;
            var text = '';
            
            stream.onmessage = function (event) {
                if (!initiated) {
                    initiated = true;
                    finEscritura();
                    endRowTyping();
                }

                var data = event.data;
                if (data != null && data !== '[DONE]') {
                    var markdown = JSON.parse(data).text;
                    text += markdown;
                    divBotMessage.innerHTML = text.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    persistChat();

                    if (stopRequested) {
                        stopRequested = false;
                        setButtonsState("idle");
                        stream.close();
                        endRowTyping();
                        finEscritura();
                        lastServerMsgCount += 2;
                        isSending = false;
                    }
                } else {
                    stream.close();
                    if (text.includes("Sorry I cannot answer")) {
                        // Eliminar el mensaje del bot si ya se insertó
                        const botRow = divBotMessage.closest(".row-chat");
                        if (botRow) botRow.remove();
                    } else {
                        divBotMessage.innerHTML = renderBotHtml(converter, text);
                    }
                    scrollChatAnimated();
                    persistChat();
                    stopRequested = false;
                    setButtonsState("idle");
                    lastServerMsgCount += 2;
                    isSending = false;
                }
            };
            
            stream.onerror = function (event) {
                console.error(event);
                stream.close();
                endRowTyping();
                divBotMessage.innerHTML = renderBotHtml(converter, text);
                finEscritura();
                scrollChatAnimated();
                persistChat();
                stopRequested = false;
                lastServerMsgCount += 2;
                isSending = false;
            };
        } else {
            endRowTyping();
            if (response.text && response.text.includes("Sorry I cannot answer")) {
                // No mostrar la respuesta
            } else {
                divBotMessage.innerHTML = renderBotHtml(converter, response.text);
                finEscritura();
            }
            scrollChatAnimated();
            persistChat();
            lastServerMsgCount += 2;
            isSending = false;
        }
    })
    .catch(error => {
        console.error('Error: ', error);
        isSending = false;
        textBox.disabled = false;
        textBox.focus();
        document.querySelector(".row-typing").style.display = 'none';
        
        const image = createBotAvatar();

        const divBotMessage = document.createElement("div");
        divBotMessage.className = "bot-reply";
        divBotMessage.innerHTML = "<span style='color:red'><i>Hubo un error en la petición del servidor. Inténtelo más tarde</i></span>";

        const divCol = document.createElement("div");
        divCol.className = "col-10 d-inline-flex";
        divCol.appendChild(image);
        divCol.appendChild(divBotMessage);

        const divChatRow = document.createElement("div");
        divChatRow.className = "row row-chat";
        divChatRow.appendChild(divCol);

        const rowTyping = document.querySelector(".row-typing");
        rowTyping.parentNode.insertBefore(divChatRow, rowTyping);
        
        scrollChatAnimated();
    });
}
